<template>
  <form id="frmFindDomain" action="/index/check-domains" method="post">
    <div class="search domains-ind">
      <div class="container">
        <div class="input">
          <input class="btn" value="FIND YOUR DOMAIN" type="button" onclick="checkDomainName();" />
          <div class="info"></div>
          <div class="nofloat">
            <input
              id="domainName"
              placeholder="Enter domain name or keyword"
              name="strDomainName"
              value=""
              type="text"
            />
          </div>
        </div>
        <!-- end .input-->
      </div>
      <!-- end .container-->
    </div>
    <!-- end .search-->

    <div class="content wide">
      <div class="tabs">
        <div class="container">
          <a class="tab active" href="#tab-all">
            All
            <span class="hide-mob">extensions</span>
          </a>
          <a class="tab" href="#tab-promo">Promotions</a>
        </div>
        <!-- end .container-->
      </div>
      <!-- end .tabs-->
      <input id="close-notice" class="outtaHere" type="checkbox" value="" />
      <div class="notice">
        <div class="container">
          Prices are shown in USD for Registration for 1 year and are subject to a payment
          processing fee.
          <label class="close" for="close-notice"></label>
        </div>
        <!-- end .container-->
      </div>
      <!-- end .notice-->

      <div class="container">
        <div id="tab-all" class="tld">
          <div class="hold">
            <div v-if="!!allDomainZones" class="clearfix">
              <template v-for="(category, index) in allDomainZones" :key="index">
                <div v-if="checkCategory(category)" class="elem">
                  <div class="row head">
                    <div class="row-in">
                      <label class="forall">
                        <input type="checkbox" value="" />
                        <span></span>
                        <span class="category-name">{{ index }}</span>
                      </label>
                    </div>
                  </div>
                  <!-- end .row-->
                  <div class="hold-in">
                    <div v-for="domainZone in category.tlds" :key="domainZone" class="row">
                      <div class="row-in">
                        <a class="go" :href="`/tld/get-info?tld=${domainZone}`"></a>
                        <span :class="priceClass(domainZone)">${{ getPrice(domainZone) }}</span>
                        <div class="info-pop">
                          <a class="icon" :href="getTldLink(domainZone)"></a>
                          <div class="pop">
                            <div class="pop-bg">
                              <span
                                v-if="getSpecialPrice(domainZone, 'promo_price')"
                                class="info bg-red"
                              >
                                {{ getBenefit(domainZone) }}%
                              </span>
                              .{{ domainZone }}
                              <ul>
                                <li>
                                  <strong :class="colorClass(domainZone, 'promo_price')">
                                    <strong :class="colorClass(domainZone, 'promo_price')">
                                      <template v-if="!!getSpecialPrice(domainZone, 'promo_price')">
                                        <del>${{ getSpecialPrice(domainZone, 'create') }}</del>
                                        ${{ getSpecialPrice(domainZone, 'promo_price') }}
                                      </template>

                                      <template v-else>
                                        ${{ getSpecialPrice(domainZone, 'create') }}
                                      </template>
                                    </strong>
                                  </strong>
                                  Registration
                                </li>
                                <li>
                                  <strong :class="colorClass(domainZone, 'promo_renew')">
                                    <template v-if="!!getSpecialPrice(domainZone, 'promo_renew')">
                                      <del>${{ getSpecialPrice(domainZone, 'renew') }}</del>
                                      ${{ getSpecialPrice(domainZone, 'promo_renew') }}
                                    </template>

                                    <template v-else>
                                      ${{ getSpecialPrice(domainZone, 'renew') }}
                                    </template>
                                  </strong>
                                  Renewal
                                </li>
                                <li>
                                  <strong :class="colorClass(domainZone, 'promo_transfer')">
                                    <template
                                      v-if="!!getSpecialPrice(domainZone, 'promo_transfer')"
                                    >
                                      <del>${{ getSpecialPrice(domainZone, 'transfer') }}</del>
                                      ${{ getSpecialPrice(domainZone, 'promo_transfer') }}
                                    </template>

                                    <template v-else>
                                      ${{ getSpecialPrice(domainZone, 'transfer') }}
                                    </template>
                                  </strong>
                                  Transfer
                                </li>
                                <li>
                                  <strong class="r green">
                                    ${{ getSpecialPrice(domainZone, 'redeem') }}
                                  </strong>
                                  Restore
                                </li>
                              </ul>
                              <!-- <?php if ($tldRequirements = Intrust_Registrar_Tlds_Utils::getRequirementByTld($domainZone)) { ?>-->
                              <div v-if="getRequirementByTld(domainZone)" class="text">
                                {{ getRequirementByTld(domainZone) }}
                              </div>
                              <!-- end .text-->
                              <a class="btn" :href="`/tld/get-info?tld=${domainZone}`">More info</a>
                            </div>
                            <!-- end .pop-bg-->
                          </div>
                          <!-- end .pop-->
                        </div>
                        <!-- end .info-pop-->
                        <a class="show-mob show-tab" :href="`/tld/get-info?tld=${domainZone}`">
                          .{{ domainZone }}
                        </a>
                        <label class="select-tld">
                          <input type="checkbox" name="tlds[]" :value="domainZone" />
                          <span></span>
                          <span class="bg"></span>
                          <span>.{{ domainZone }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <!-- end .hold-in-->
                </div>
              </template>
            </div>
          </div>
          <!-- end .hold-->
        </div>
        <!-- end .tld-->

        <!-- PROMO TAB -->
        <div id="tab-promo" class="tld" style="display: none">
          <div class="hold">
            <div v-if="!!promoDomainZones && Object.keys(promoDomainZones)" class="clearfix">
              <template v-for="(category, index) in promoDomainZones" :key="index">
                <div v-if="!!category && Object.keys(category)" class="elem">
                  <div class="row head">
                    <div class="row-in">
                      <label class="forall">
                        <input type="checkbox" value="" />
                        <span></span>
                        <span class="category-name">{{ index }}</span>
                      </label>
                    </div>
                  </div>
                  <!-- end .row-->
                  <div class="hold-in">
                    <div v-for="(domainZone, zoneIndex) in category" :key="zoneIndex" class="row">
                      <div class="row-in">
                        <a class="go" :href="`/tld/get-info?tld=${zoneIndex}`"></a>
                        <span class="price red">${{ getPrice(zoneIndex) }}</span>
                        <div class="info-pop">
                          <a class="icon" :href="getTldLink(zoneIndex)"></a>
                          <div class="pop">
                            <div class="pop-bg">
                              <span
                                v-if="getSpecialPrice(zoneIndex, 'promo_price')"
                                class="info bg-red"
                              >
                                {{ getBenefit(zoneIndex) }}%
                              </span>
                              .{{ zoneIndex }}
                              <ul>
                                <li>
                                  <strong :class="colorClass(zoneIndex, 'promo_price')">
                                    <strong :class="colorClass(zoneIndex, 'promo_price')">
                                      <template v-if="!!getSpecialPrice(zoneIndex, 'promo_price')">
                                        <del>${{ getSpecialPrice(zoneIndex, 'create') }}</del>
                                        ${{ getSpecialPrice(zoneIndex, 'promo_price') }}
                                      </template>

                                      <template v-else>
                                        ${{ getSpecialPrice(zoneIndex, 'create') }}
                                      </template>
                                    </strong>
                                  </strong>
                                  Registration
                                </li>
                                <li>
                                  <strong :class="colorClass(zoneIndex, 'promo_renew')">
                                    <template v-if="!!getSpecialPrice(domainZone, 'promo_renew')">
                                      <del>${{ getSpecialPrice(zoneIndex, 'renew') }}</del>
                                      ${{ getSpecialPrice(zoneIndex, 'promo_renew') }}
                                    </template>

                                    <template v-else>
                                      ${{ getSpecialPrice(zoneIndex, 'renew') }}
                                    </template>
                                  </strong>
                                  Renewal
                                </li>
                                <li>
                                  <strong :class="colorClass(zoneIndex, 'promo_transfer')">
                                    <template v-if="!!getSpecialPrice(zoneIndex, 'promo_transfer')">
                                      <del>${{ getSpecialPrice(zoneIndex, 'transfer') }}</del>
                                      ${{ getSpecialPrice(zoneIndex, 'promo_transfer') }}
                                    </template>

                                    <template v-else>
                                      ${{ getSpecialPrice(zoneIndex, 'transfer') }}
                                    </template>
                                  </strong>
                                  Transfer
                                </li>
                                <li>
                                  <strong class="r green">
                                    ${{ getSpecialPrice(zoneIndex, 'redeem') }}
                                  </strong>
                                  Restore
                                </li>
                              </ul>
                              <div v-if="getRequirementByTld(zoneIndex)" class="text">
                                {{ getRequirementByTld(zoneIndex) }}
                              </div>
                              <!-- end .text-->
                              <a class="btn" :href="`/tld/get-info?tld=${zoneIndex}`">More info</a>
                            </div>
                            <!-- end .pop-bg-->
                          </div>
                          <!-- end .pop-->
                        </div>
                        <!-- end .info-pop-->
                        <a class="show-mob show-tab" :href="`/tld/get-info?tld=${zoneIndex}`">
                          .{{ zoneIndex }}
                        </a>
                        <label class="select-tld">
                          <input type="checkbox" name="tlds[]" :value="zoneIndex" />
                          <span></span>
                          <span class="bg"></span>
                          <span>.{{ zoneIndex }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <!-- end .hold-in-->
                </div>
              </template>
            </div>
          </div>
          <!-- end .hold-->
          <!--div class="more">Show more zones</div-->
          <!-- end .more-->
        </div>

        <div class="features2">
          <div class="half">
            <a class="bg" href="/index/whois-privacy">
              <img src="/pananames/img/features/10.png" width="64" height="64" alt=" " />
              <div class="cell">
                Free
                <br />
                Whois privacy
              </div>
            </a>
            <!-- end .bg-->
          </div>
          <!-- end .half-->
          <div class="half">
            <a class="bg" href="" onclick="return false;">
              <img src="/pananames/img/features/4.png" width="64" height="64" alt=" " />
              <div class="cell">
                Free URL/EMAIL
                <br />
                forwards
              </div>
            </a>
            <!-- end .bg-->
          </div>
          <!-- end .half-->
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'PricingPage',
  setup() {
    const pricingData = window.pricingData
    const allDomainZones = JSON.parse(pricingData.allDomainZones)
    const promoDomainZones = JSON.parse(pricingData.promoDomainZones)
    const tldPrices = JSON.parse(pricingData.tldPrices)
    const tldDescRequirment = pricingData.resultDesc

    function getSpecialPrice(tld, priceType) {
      if (!!tldPrices && !!tldPrices[tld] && !!tldPrices[tld][priceType]) {
        return tldPrices[tld][priceType].toFixed(2)
      }
      return 0
    }

    function getPrice(tld) {
      const special = getSpecialPrice(tld, 'promo_price')
      const defaultPrice = getSpecialPrice(tld, 'create')

      return special ? special : defaultPrice
    }

    function checkCategory(category) {
      return !!category && category.tlds.length
    }

    function getBenefit(tld) {
      const promo = getSpecialPrice(tld, 'promo_price')
      const defaultPrice = getSpecialPrice(tld, 'create')

      return ((promo / defaultPrice) * 100 - 100).toFixed(0)
    }

    function getDescByTld(tld) {
      if (!!tldDescRequirment && !!tldDescRequirment[tld] && !!tldDescRequirment[tld]['desc']) {
        return tldDescRequirment[tld]['desc']
      }
      return false
    }

    function getTldLink(tld) {
      return getDescByTld(tld) ? `/tld/get-info?tld=${tld}` : 'javascript:void(0);'
    }

    function priceClass(tld) {
      let res = 'price'
      if (getSpecialPrice(tld, 'promo_price')) res += ' red'
      return res
    }

    function getRequirementByTld(tld) {
      if (
        !!tldDescRequirment &&
        !!tldDescRequirment[tld] &&
        !!tldDescRequirment[tld]['requirements']
      ) {
        return tldDescRequirment[tld]['requirements']
      }
      return false
    }

    function colorClass(tld, type) {
      let res = 'r'
      res += getSpecialPrice(tld, type) ? ' red' : ' green'
      return res
    }

    return {
      allDomainZones,
      tldPrices,
      promoDomainZones,
      getSpecialPrice,
      getPrice,
      checkCategory,
      priceClass,
      getBenefit,
      colorClass,
      getTldLink,
      getRequirementByTld,
    }
  },
}
</script>

<style lang="sass" scoped>
@media only screen and (max-width: 1100px)
  .info-pop .icon
    display: block
    float: right

  .info-pop .pop
    display: block
    float: right

  .info-pop
    float: right

@media only screen and (max-width: 767px)
  .tld .info-pop, .tld .row input + *
    display: table-cell

  .tld .row input + *
    position: relative
    top: 0

  .tld .bg + span
    margin-left: 6px

  .category-name
    display: inline-block
    margin-left: 6px

  .info-pop .icon
    display: none

  .info-pop .pop
    display: none
</style>
